module.exports = __webpack_public_path__ + "static/media/51.d6569c1a.jpg";